let code = 'toponymygestao';
let codeAPI = 'toponymy';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};